module.exports = __webpack_public_path__ + "static/media/import.9d4f6b4d.svg";